const fontMetricsList = [
  {
    "familyName": "Thieme Argo 2011 Light",
    "fullName": "Thieme Argo 2011 Light",
    "postscriptName": "ThiemeArgo2011-Light",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 890,
    "subsets": {
      "latin": {
        "xWidthAvg": 890
      },
      "thai": {
        "xWidthAvg": 1381
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 Light",
    "fullName": "Thieme Argo 2011 Light Italic",
    "postscriptName": "ThiemeArgo2011-LightItalic",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 840,
    "subsets": {
      "latin": {
        "xWidthAvg": 840
      },
      "thai": {
        "xWidthAvg": 1381
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011",
    "fullName": "Thieme Argo 2011 Italic",
    "postscriptName": "ThiemeArgo2011-Italic",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 843,
    "subsets": {
      "latin": {
        "xWidthAvg": 843
      },
      "thai": {
        "xWidthAvg": 1380
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 Medium",
    "fullName": "Thieme Argo 2011 Medium",
    "postscriptName": "ThiemeArgo2011-Medium",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 922,
    "subsets": {
      "latin": {
        "xWidthAvg": 922
      },
      "thai": {
        "xWidthAvg": 1381
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011",
    "fullName": "Thieme Argo 2011",
    "postscriptName": "ThiemeArgo2011-Regular",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 890,
    "subsets": {
      "latin": {
        "xWidthAvg": 890
      },
      "thai": {
        "xWidthAvg": 1380
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 SemiBold",
    "fullName": "Thieme Argo 2011 SemiBold Italic",
    "postscriptName": "ThiemeArgo2011-SemiBoldItalic",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 875,
    "subsets": {
      "latin": {
        "xWidthAvg": 875
      },
      "thai": {
        "xWidthAvg": 1380
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 SemiBold",
    "fullName": "Thieme Argo 2011 SemiBold",
    "postscriptName": "ThiemeArgo2011-SemiBold",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 921,
    "subsets": {
      "latin": {
        "xWidthAvg": 921
      },
      "thai": {
        "xWidthAvg": 1380
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 Medium",
    "fullName": "Thieme Argo 2011 Medium Italic",
    "postscriptName": "ThiemeArgo2011-MediumItalic",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 877,
    "subsets": {
      "latin": {
        "xWidthAvg": 877
      },
      "thai": {
        "xWidthAvg": 1381
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 SemiBold",
    "fullName": "Thieme Argo 2011 SemiBold Italic",
    "postscriptName": "ThiemeArgo2011-SemiBoldItalic",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 875,
    "subsets": {
      "latin": {
        "xWidthAvg": 875
      },
      "thai": {
        "xWidthAvg": 1380
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 Light",
    "fullName": "Thieme Argo 2011 Light Bold",
    "postscriptName": "ThiemeArgo2011-Bold",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 948,
    "subsets": {
      "latin": {
        "xWidthAvg": 948
      },
      "thai": {
        "xWidthAvg": 1381
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 Light",
    "fullName": "Thieme Argo 2011 Light Bold Italic",
    "postscriptName": "ThiemeArgo2011-BoldItalic",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 906,
    "subsets": {
      "latin": {
        "xWidthAvg": 906
      },
      "thai": {
        "xWidthAvg": 1381
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 ExtraBold",
    "fullName": "Thieme Argo 2011 ExtraBold",
    "postscriptName": "ThiemeArgo2011-ExtraBold",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 949,
    "subsets": {
      "latin": {
        "xWidthAvg": 949
      },
      "thai": {
        "xWidthAvg": 1380
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 ExtraBold",
    "fullName": "Thieme Argo 2011 ExtraBold Italic",
    "postscriptName": "ThiemeArgo2011-ExtraBoldItalic",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 902,
    "subsets": {
      "latin": {
        "xWidthAvg": 902
      },
      "thai": {
        "xWidthAvg": 1380
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 Black",
    "fullName": "Thieme Argo 2011 Black Italic",
    "postscriptName": "ThiemeArgo2011-BlackItalic",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 946,
    "subsets": {
      "latin": {
        "xWidthAvg": 946
      },
      "thai": {
        "xWidthAvg": 1381
      }
    }
  },
  {
    "familyName": "Thieme Argo 2023 Variable",
    "fullName": "Thieme Argo 2023 Variable",
    "postscriptName": "ThiemeArgo2023Variable-Regular",
    "capHeight": 707,
    "ascent": 950,
    "descent": -244,
    "lineGap": 0,
    "unitsPerEm": 1000,
    "xHeight": 511,
    "xWidthAvg": 435,
    "subsets": {
      "latin": {
        "xWidthAvg": 435
      },
      "thai": {
        "xWidthAvg": 500
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 ExtraBold",
    "fullName": "Thieme Argo 2011 ExtraBold Italic",
    "postscriptName": "ThiemeArgo2011-ExtraBoldItalic",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 902,
    "subsets": {
      "latin": {
        "xWidthAvg": 902
      },
      "thai": {
        "xWidthAvg": 1380
      }
    }
  },
  {
    "familyName": "Thieme Argo 2023 IT Variable ",
    "fullName": "Thieme Argo 2023 IT Variable",
    "postscriptName": "ThiemeArgo2023ITVariable-Italic",
    "capHeight": 707,
    "ascent": 950,
    "descent": -244,
    "lineGap": 0,
    "unitsPerEm": 1000,
    "xHeight": 509,
    "xWidthAvg": 412,
    "subsets": {
      "latin": {
        "xWidthAvg": 412
      },
      "thai": {
        "xWidthAvg": 500
      }
    }
  },
  {
    "familyName": "Thieme Argo 2011 Black",
    "fullName": "Thieme Argo 2011 Black",
    "postscriptName": "ThiemeArgo2011-Black",
    "capHeight": 1446,
    "ascent": 1950,
    "descent": -500,
    "lineGap": 0,
    "unitsPerEm": 2048,
    "xHeight": 1041,
    "xWidthAvg": 984,
    "subsets": {
      "latin": {
        "xWidthAvg": 984
      },
      "thai": {
        "xWidthAvg": 1381
      }
    }
  },
  {
    "familyName": "Font Awesome 6 Free Regular",
    "fullName": "Font Awesome 6 Free Regular",
    "postscriptName": "FontAwesome6Free-Regular",
    "capHeight": 428,
    "ascent": 456,
    "descent": -72,
    "lineGap": 0,
    "unitsPerEm": 512,
    "xHeight": 319,
    "xWidthAvg": 369,
    "subsets": {
      "latin": {
        "xWidthAvg": 369
      },
      "thai": {
        "xWidthAvg": 384
      }
    }
  },
  {
    "familyName": "Font Awesome 6 Brands Regular",
    "fullName": "Font Awesome 6 Brands Regular",
    "postscriptName": "FontAwesome6Brands-Regular",
    "capHeight": 432,
    "ascent": 460,
    "descent": -75,
    "lineGap": 0,
    "unitsPerEm": 512,
    "xHeight": 322,
    "xWidthAvg": 369,
    "subsets": {
      "latin": {
        "xWidthAvg": 369
      },
      "thai": {
        "xWidthAvg": 384
      }
    }
  },
  {
    "familyName": "FluentSystemIcons-Resizable",
    "fullName": "FluentSystemIcons-Resizable",
    "postscriptName": "FluentSystemIcons-Resizable",
    "capHeight": 0,
    "ascent": 500,
    "descent": 0,
    "lineGap": 0,
    "unitsPerEm": 500,
    "xHeight": 0,
    "xWidthAvg": 0,
    "subsets": {
      "latin": {
        "xWidthAvg": 0
      },
      "thai": {
        "xWidthAvg": 0
      }
    }
  },
  {
    "familyName": "Font Awesome v4 Compatibility Regular",
    "fullName": "Font Awesome v4 Compatibility Regular",
    "postscriptName": "FontAwesomev4Compatibility-Regular",
    "capHeight": 427,
    "ascent": 455,
    "descent": -71,
    "lineGap": 0,
    "unitsPerEm": 512,
    "xHeight": 318,
    "xWidthAvg": 384,
    "subsets": {
      "latin": {
        "xWidthAvg": 384
      },
      "thai": {
        "xWidthAvg": 384
      }
    }
  },
  {
    "familyName": "bootstrap-icons",
    "fullName": "bootstrap-icons",
    "postscriptName": "bootstrap-icons",
    "capHeight": 0,
    "ascent": 300,
    "descent": 0,
    "lineGap": 0,
    "unitsPerEm": 300,
    "xHeight": 0,
    "xWidthAvg": 0,
    "subsets": {
      "latin": {
        "xWidthAvg": 0
      },
      "thai": {
        "xWidthAvg": 0
      }
    }
  },
  {
    "familyName": "Font Awesome 6 Free Solid",
    "fullName": "Font Awesome 6 Free Solid",
    "postscriptName": "FontAwesome6Free-Solid",
    "capHeight": 431,
    "ascent": 459,
    "descent": -75,
    "lineGap": 0,
    "unitsPerEm": 512,
    "xHeight": 321,
    "xWidthAvg": 369,
    "subsets": {
      "latin": {
        "xWidthAvg": 369
      },
      "thai": {
        "xWidthAvg": 384
      }
    }
  }
];
export default fontMetricsList;